<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    title="服务类目"
    namespace="wechat_third_party_platform/"
    resource="wechat_categories"
    :actionButtons="isPlatformApplication ? ['new'] : []"
    :onFormSubmit="handleSubmit"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { WECHAT_CATEGORY_AUDIT_STATUSES } from '@/constants';
import WechatCategoryForm from '@/components/wechat-category';

@Component
export default class WechatCategory extends Vue {
  @Prop(String) type;
  @Prop(String) applicationSource;

  // form 新建表单初始化数据（default数据）
  form = {}

  get isPlatformApplication() {
    return this.applicationSource === 'platform';
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'first_name',
        label: '一级类目名称',
        width: 120,
      },
      {
        prop: 'second_name',
        label: '二级类目名称',
        width: 120,
      },
      {
        prop: 'audit_status',
        label: '审核状态',
        minWidth: 120,
        renderCell: (h, { props: { value } }) => {
          return <el-tag>{ WECHAT_CATEGORY_AUDIT_STATUSES[value] }</el-tag>;
        }
      },
      {
        prop: 'audit_reason',
        label: '审核不通过原因',
        width: 150,
        renderCell: (h, { props: { scope: { row }, value } }) => {
          // 2 表示审核未通过
          if (row.audit_status === 2) {
            return <p>{ value }</p>;
          } else {
            return <p>/</p>
          }
        }
      },
    ];
  }


  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'categories',
        label: '类目信息',
        renderCell: {
          component: (h, context) => <WechatCategoryForm {...context} />,
          required: true
        }
      },
    ].filter(Boolean);
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { reload }) {
    const certicateColumns = [
      {
        prop: 'key',
        label: '资质名称',
        renderCell: {
          component: 'input',
          required: true,
          hint: 'eg:《因私出入境中介机构经营许可证》'
        }
      },
      {
        prop: 'value',
        label: '资质图片',
        renderCell: {
          component: 'upload',
          required: true,
          hint: '上传原件或复印件，复印件务必加盖公司公章。文件格式为jpg、jpeg、bmp、gif或png，文件大小不超过10M。资质可拼图上传。',
          props: {
            size: 10
          }
        }
      }
    ];

    const categoryColumns = [
      {
        prop: 'first_name',
        label: '一级类目名称',
        renderCell: {
          component: 'input',
          props: {
            disabled: true
          }
        }
      },
      {
        prop: 'second_name',
        label: '二级类目名称',
        renderCell: {
          component: 'input',
          props: {
            disabled: true
          }
        }
      },
      {
        prop: 'certicates',
        label: '资质信息',
        renderCell: {
          component: 'nestForm',
          required: true,
          props: {
            columns: certicateColumns
          }
        }
      }
    ]

    const handleSubmitCerticates =  async (data) => {
      await this.$request.put('/wechat_third_party_platform/wechat_categories', data)
    }

    const handleDelete = async (first, second) => {
      await this.$request.delete(`/wechat_third_party_platform/wechat_categories?first=${first}&second=${second}`);
      this.$message.success(this.$t('bean.deleteSuccess'));
      reload();
    }

    return [
      this.isPlatformApplication && {
        component: 'confirmButton',
        props: {
          label: '删除',
          type: 'danger',
          can: 'wechat_categories.destroy'
        },
        on: {
          confirm: () => handleDelete(row.first, row.second)
        }
      },
      // 审核不通过，需提交资质信息
      this.isPlatformApplication && row.audit_status === 2 && {
        component: 'dialogFormButton',
        props: {
          label: '提交资质信息',
          columns: categoryColumns,
          value: row,
          can: 'wechat_categories.update',
          submitHandler: handleSubmitCerticates
        }
      }
    ].filter(Boolean);
  }

  async handleSubmit({ data, type, resource, namespace }) {
    if (type === 'new') {
      await this.$request.post(`/${namespace}${resource}`, data);
      this.$message.success('创建成功');
    } else {
      await this.$request.put(`/${namespace}${resource}/${data.id}`, data);
      this.$message.success('更新成功');
    }
    this.$router.go(-1);
  }
}


export const route = [
  {
    path: '/wechat_categories',
    name: 'wechat_categories.index',
    component: WechatCategory,
    props: {
      type: 'index',
    }
  },
  {
    path: '/wechat_categories/new',
    name: 'wechat_categories.new',
    component: WechatCategory,
    props: {
      type: 'new',
    }
  },
  {
    path: '/wechat_categories/:id',
    name: 'wechat_categories.show',
    component: WechatCategory,
    props: {
      type: 'show',
    }
  },
]
</script>
